const auth_status = {
    page_title: 'Auth status',
    title: 'Auth status',
    description: 'Check the status of authentication.',
};
export default Object.freeze(auth_status);
